var _excluded = ["appearance", "children", "colorScheme", "customStyle", "disabled", "expanded", "forceActive", "leadingIcon", "loading", "small", "type", "trailingIcon"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import useStyles from './use_styles';
import { useTheme } from '@veneer/theme';
import { jsx } from '@emotion/react';
import { isMobile } from 'react-device-detect';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import ProgressIndicator from '../progress_indicator';
import isVeneerIcon from '../utils/is_veneer_icon';
import { getComponentDisplayName } from '../utils/forward_props';
import { jsx as ___EmotionJSX } from "@emotion/react";
function cloneIcon(icon) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var veneerProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return /*#__PURE__*/React.cloneElement(icon, _objectSpread(_objectSpread({
    'aria-hidden': true
  }, props), isVeneerIcon(icon) && veneerProps));
}
var buttonAs = component => {
  var displayName = getComponentDisplayName(component, 'Button');
  var Wrapped = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    var {
        appearance = 'primary',
        children,
        colorScheme = 'default',
        customStyle,
        disabled = false,
        expanded = false,
        forceActive = false,
        leadingIcon,
        loading = false,
        small = false,
        type = 'button',
        trailingIcon
      } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);
    var isDisabledOrLoading = disabled || loading;
    var renderLeadingIcon = Boolean(leadingIcon && !trailingIcon);
    var renderTrailingIcon = Boolean(!leadingIcon && trailingIcon);
    var isIconButton = Boolean(renderLeadingIcon && !children);
    var style = useStyles(colorScheme);
    var theme = useTheme();
    var isWarning = colorScheme === 'warning';
    var isCaution = colorScheme === 'caution';
    var isLight = theme.mode === 'light';
    var isHc = theme.mode === 'contrast';
    var isPill = theme.shape === 'pill';
    var primaryStyles = [style.rootPrimary, !isMobile && style.rootPrimaryHover, isDisabledOrLoading && style.disabledOrLoadingPrimary, forceActive && style.rootPrimaryActive];
    var secondaryStyles = [style.rootSecondary, isLight && (isWarning || isCaution) && style.rootSecondaryOverride, !isMobile && [style.rootSecondaryHover, isLight && (isWarning || isCaution) && style.rootSecondaryHoverOverride], isDisabledOrLoading && style.disabledOrLoadingSecondary, forceActive && [style.rootSecondaryActive, isLight && (isWarning || isCaution) && style.rootSecondaryActiveOverride], isHc && [style.rootHc, !isMobile && style.rootHoverHc, forceActive && style.rootActiveHc]];
    var ghostStyles = [style.rootGhost, isLight && (isWarning || isCaution) && style.rootGhostOverride, !isMobile && [style.rootGhostHover, isLight && (isWarning || isCaution) && style.rootGhostHoverOverride], isDisabledOrLoading && style.disabledOrLoadingGhost, small && style.rootGhostSmall, renderLeadingIcon && style.rootGhostLeadingIcon, renderTrailingIcon && style.rootGhostTrailingIcon, renderLeadingIcon && small && style.rootGhostLeadingIconSmall, renderTrailingIcon && small && style.rootGhostTrailingIconSmall, forceActive && [style.rootGhostActive, isLight && (isWarning || isCaution) && style.rootGhostActiveOverride], isHc && [style.rootHc, !isMobile && style.rootHoverHc, forceActive && style.rootActiveHc]];
    var content = ___EmotionJSX(React.Fragment, null, renderLeadingIcon && ___EmotionJSX("span", {
      css: style.icon
    }, /*#__PURE__*/React.isValidElement(leadingIcon) && ___EmotionJSX(React.Fragment, null, cloneIcon(leadingIcon, {
      className: [leadingIcon.props.className, 'vn-icon-inactive'].filter(Boolean).join(' ')
    }, {
      filled: leadingIcon.props.filled
    }), cloneIcon(leadingIcon, {
      className: [leadingIcon.props.className, 'vn-icon-active'].filter(Boolean).join(' ')
    }, {
      filled: true
    }))), children && ___EmotionJSX("span", {
      css: style.label
    }, children), renderTrailingIcon && ___EmotionJSX("span", {
      css: style.icon
    }, /*#__PURE__*/React.isValidElement(trailingIcon) && ___EmotionJSX(React.Fragment, null, cloneIcon(trailingIcon, {
      className: [trailingIcon.props.className, 'vn-icon-inactive'].filter(Boolean).join(' ')
    }, {
      filled: trailingIcon.props.filled
    }), cloneIcon(trailingIcon, {
      className: [trailingIcon.props.className, 'vn-icon-active'].filter(Boolean).join(' ')
    }, {
      filled: true
    }))), loading && ___EmotionJSX(ProgressIndicator, {
      css: style.spinner,
      "aria-hidden": true
    }));
    return jsx(component, _objectSpread(_objectSpread({
      ref,
      css: [style.base, style.root, forceActive && style.rootActive, renderLeadingIcon && style.rootLeadingIcon, renderTrailingIcon && style.rootTrailingIcon, small && style.rootSmall, renderLeadingIcon && small && style.rootLeadingIconSmall, renderTrailingIcon && small && style.rootTrailingIconSmall, expanded && style.rootExpanded, appearance === 'primary' && primaryStyles, appearance === 'secondary' && secondaryStyles, appearance === 'ghost' && ghostStyles, isIconButton && style.rootIcon, isIconButton && small && style.rootIconSmall, isDisabledOrLoading && style.disabledOrLoading, loading && style.loading, isPill && style.pill, highContrastMediaQuery(theme), customStyle],
      'aria-busy': loading ? loading : undefined,
      'aria-disabled': loading ? loading : undefined,
      disabled: disabled,
      type: type
    }, rest), {}, {
      onClick: isDisabledOrLoading ? undefined : rest.onClick,
      href: isDisabledOrLoading ? undefined : rest.href
    }), content);
  });
  Wrapped.displayName = displayName;
  return Wrapped;
};
export default buttonAs;